<template>
    <!-- Begin Partner Area -->
    <div id="sponsor" class="partner-area ">
        <div class="container">
            <div class="row mt-5">
                <div class="col-12">
                    <div class="section-area section-style-2">
                      <h2 class="section-title">I nostri Partners</h2>
                        <!-- Partner Arrows -->
                        <div class="partner-arrow-wrap">
                            <!-- Swiper Navigation Start -->
                            <div class="partner-button-prev swipper-arrow">
                                <i class="icofont-double-left"></i>
                            </div>
                            <div class="partner-button-next swipper-arrow">
                                <i class="icofont-double-right"></i>
                            </div>
                            <!-- Swiper Navigation End -->
                        </div>
                    </div>
                    <div class="partner-slider">

                        <swiper class="partner-slider"
                            :breakpoints="swiperOptions.breakpoints"
                            :slides-per-view="3"
                            :spaceBetween="60"
                            :loop="true"
                            :navigation="swiperOptions.navigation"
                            @swiper="onSwiper"
                        >
                            <swiper-slide class="partner-item" v-for="(partner, index) in partners" :key="index">
                                <span class="partner-img">
                                  <a :href=partner.url target="_blank"><img :src="`${partner.partnerImage}`" :alt="partner.alt"></a>
                                </span>
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Partner Area End Here -->
</template>

<script>
import SwiperCore, { Navigation } from 'swiper/core'
import { Swiper, SwiperSlide } from 'swiper/vue'
SwiperCore.use([Navigation])

export default {
  components: {
    Swiper,
    SwiperSlide
  },

  data () {
    return {
      swiperOptions: {
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 30
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          1100: {
            slidesPerView: 4,
            spaceBetween: 60
          }
        },
        navigation: {
          nextEl: '.partner-area .partner-button-next',
          prevEl: '.partner-area .partner-button-prev'
        }
      },

      partners: [
        {
          partnerImage: 'images/partner/primiceri.png',
          alt: 'Trasporti F.lli Primiceri',
          url:'https://www.trasportiprimiceri.com/'
        },
        {
          partnerImage: 'images/partner/Lotras.png',
          alt: 'Lotras logistics & Eco Transport',
          url:'https://www.lotras.it/it/'
        },
        {
          partnerImage: 'images/partner/merola.png',
          alt: 'Francesco Merola Carburanti',
        },
        {
          partnerImage: 'images/partner/tgl.png',
          alt: 'TheGINLABs',
          url:'https://www.theginlabs.it'
        },
        {
          partnerImage: 'images/partner/serra.png',
          alt: 'Officine Serravezza',
        },
        {
          partnerImage: 'images/partner/wifinetcom.png',
          alt: 'WiFiNetcom SRL',
          url:'https://www.wifinetcom.net/'
        },
        {
          partnerImage: 'images/partner/gpl.png',
          alt: 'Green Planet Logistics',
          url:'https://www.greenplanetlogistics.net/'
        },
        {
          partnerImage: 'images/partner/toma.png',
          alt: 'Toma Carburanti s.r.l.',
        },
        {
          partnerImage: 'images/partner/coverize.png',
          alt: 'Coverize dei F.lli De Nuzzo s.r.l.',
        },
        {
          partnerImage: 'images/partner/ascla.png',
          alt: 'Ascla ',
          url:'https://www.ascla.net/'
        },
        {
          partnerImage: 'images/partner/euroverde.png',
          alt: 'Euroverde Garden Center',
          url:'https://euroverdegarden.it/'
        },
        {
          partnerImage: 'images/partner/ACI.png',
          alt: 'ACI',
        },
        {
          partnerImage: 'images/partner/SARA.png',
          alt: 'Sara Assicurazioni',
        },
        {
          partnerImage: 'images/partner/carangelo.png',
          alt: 'F.lli Carangelo snc',
        },
        {
          partnerImage: 'images/partner/sorano.png',
          alt: 'Autofficina Sorano srl',
        },
        {
          partnerImage: 'images/partner/costa.png',
          alt: 'Costa Officina V.I. s.a.s',
          url:'https://www.costaofficinavi.it/'
        },
        {
          partnerImage: 'images/partner/pw.png',
          alt: 'Palletways',
          url:'https://it.palletways.com/it'
        },
        {
          partnerImage: 'images/partner/marraffa.png',
          alt: 'Marraffa s.r.l.',
          url:'https://www.marraffa.it/it/?gad_source=1&gad_campaignid=1620416766&gbraid=0AAAAAC_oBadiYuEJGxwysK0-77NVRVse9&gclid=Cj0KCQjw3OjGBhDYARIsADd-uX4-qbFUjlFMNWL263ezgw82JD4HgBj8qln9Lz-acEcsFKePt4fuY3UaArMsEALw_wcB'
        },
        {
          partnerImage: 'images/partner/marevivo.png',
          alt: 'Mare Vivo',
          url:'https://www.mondomarevivo.com/'
        },
        {
          partnerImage: 'images/partner/primicerilogistica.png',
          alt: 'Primiceri Logistica',
        },
        {
          partnerImage: 'images/partner/decorline.png',
          alt: 'Decorline',
        },
      ],
    }
  },

  methods: {
    onSwiper (swiper) {
      this.swiper = swiper
    }
  }
}
</script>
